import i18n from "i18n";

export const PARAMETERS_CONFIG = [
  {
    name: "ExpirationPeriodDays",
    label: i18n.t("reportRejectedTime"),
    type: "number",
    defaultValue: 7,
    parse: (v) => Number(v),
  },
  {
    name: "MinimumVerAndroid",
    label: i18n.t("minimumVerAndroid"),
    type: "text",
    defaultValue: "",
  },
  {
    name: "MinimumVerIos",
    label: i18n.t("minimumVerIos"),
    type: "text",
    defaultValue: "",
  },
  {
    name: "LatestVerAndroid",
    label: i18n.t("latestVerAndroid"),
    type: "text",
    defaultValue: "",
  },
  {
    name: "LatestVerIos",
    label: i18n.t("latestVerIos"),
    type: "text",
    defaultValue: "",
  },
];
